import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
`;

export const ModalContainer = styled.div`
  background: white;
  padding-top: 75px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 100%;
  min-height: 200px;
  min-width: 280px;
  position: relative;

  @media (min-width: 768px) {
    margin-top: 0;
    padding: 75px 60px 60px;
    max-width: 640px;
    width: auto;
    height: auto;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  color: black;
  padding: 12px;
  background: transparent;
  border: none;
  cursor: pointer;

  &:hover {
    color: black;
  }
`;

export const Content = styled.div`
  font-size: 14px;
  color: #585a5f;
  line-height: 22px;
  overflow: auto;
  height: 100%;
  letter-spacing: 0.05em;
  font-weight: normal;
  margin-top: 0;

  p {
    margin-bottom: 20px;
  }

  @media (min-width: 768px) {
    height: auto;
  }
`;
